export default __webpack_public_path__ + "static/media/classes.d79e68ed.csv";